import { AlertTriangle } from 'lucide-react';

/**
 * DisclaimerBanner — warning ±10% о приблизительном характере расчёта.
 *
 * Прототип 2.12.2 lines 345-348 (применяется в каждом 2.12.{2..9}):
 *   `<div style={{ margin: '12px 12px 0', padding: '10px 14px',
 *    background: '#fff8e8', border: '1px solid YL', borderRadius: 12,
 *    display: 'flex', alignItems: 'flex-start', gap: 10 }}>
 *      <Ic name="AlertTriangle" size={22} color="#d97706" />
 *      <span style={{ fontSize: 17, color: DK, lineHeight: 1.4 }}>
 *        Расчёт примерный. Погрешность <strong>±10%</strong>. Закладывайте запас 10%.
 *      </span>
 *   </div>`
 *
 * NB: TZ Step 8 spec'нул `AlertCircle` icon — это typo; прототип использует
 * `AlertTriangle` (matches warning amber #d97706). Также CalculatorEntryView
 * line 75 уже использует AlertTriangle для аналогичного disclaimer pattern —
 * consistent reuse.
 *
 * Styling — Tailwind tokens + inline для prototype-fidelity:
 * - `bg-warning/10` ≈ #fff8e8 (warning #d97706 at 10% opacity ≈ light cream)
 * - `border-cta` = #f5c400 = YL (exact match prototype border)
 * - `text-warning` = #d97706 на иконке
 * - fontSize 17px inline — exact match прототип (Tailwind text-base=16, не подходит)
 *
 * Рендерится at top of AnketaForm main content (перед sections).
 */
export function DisclaimerBanner() {
  return (
    <div
      role="note"
      aria-label="Внимание — приблизительный расчёт ±10%"
      className="flex items-start gap-2 rounded-xl bg-warning/10 border border-cta mx-3 px-4 py-3"
    >
      <AlertTriangle className="flex-shrink-0 text-warning" size={22} aria-hidden="true" />
      <span className="text-ink leading-snug" style={{ fontSize: '17px' }}>
        Расчёт примерный. Погрешность <strong>±10%</strong>. Закладывайте запас 10%.
      </span>
    </div>
  );
}
